import { useToggle } from '@uidotdev/usehooks';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

type Options = {
  dialogTitle?: string;
  openModalButtonText?: string;
};

/**
 * Open state and labels of the `Uploader` modal. The dialog title and the
 * open button label fall back to the `ui:uploader` translations.
 */
export function useUploaderModal({
  dialogTitle,
  openModalButtonText,
}: Options) {
  const { t } = useTranslation('ui');

  const [isOpen, toggleOpen] = useToggle(false);

  const handleOpen = useCallback(() => {
    toggleOpen(true);
  }, [toggleOpen]);
  const closeModal = useCallback(() => {
    toggleOpen(false);
  }, [toggleOpen]);

  return {
    closeModal,
    handleOpen,
    isOpen,
    resolvedDialogTitle: dialogTitle ?? t(($) => $.uploader.dialogTitle),
    resolvedOpenModalButtonText:
      openModalButtonText ?? t(($) => $.uploader.openModalButton),
  };
}
